// 채널 관리 관련 공통 상수

// PlanType 타입 정의
export type PlanType = 'free' | 'pro' | 'enterprise' | 'teacher' | 'class' | 'realworld';

// 요금제 타입 레이블 매핑 (모든 케이스 포함)
export const PLAN_TYPE_LABELS: Record<string, string> = {
  // 소문자
  free: '무료',
  pro: '프로',
  enterprise: '엔터프라이즈',
  teacher: '티처',
  class: '클래스',
  realworld: '리얼월드',
  // 대문자
  FREE: '무료',
  PRO: '프로',
  ENTERPRISE: '엔터프라이즈',
  TEACHER: '티처',
  CLASS: '클래스',
  REALWORLD: '리얼월드',
  // 첫 글자만 대문자
  Free: '무료',
  Pro: '프로',
  Enterprise: '엔터프라이즈',
  Teacher: '티처',
  Class: '클래스',
  Realworld: '리얼월드',
};

// 요금제 옵션 (SelectField용)
export const PLAN_OPTIONS = [
  { value: 'free', label: '무료' },
  { value: 'pro', label: '프로' },
  { value: 'enterprise', label: '엔터프라이즈' },
  { value: 'teacher', label: '티처' },
  { value: 'class', label: '클래스' },
  { value: 'realworld', label: '리얼월드' },
];

// 요금제 필터 옵션 (필터 드롭다운용)
export const PLAN_FILTER_ITEMS = [
  { value: 'all' as const, label: '전체 보기' },
  { value: 'free' as const, label: '무료' },
  { value: 'pro' as const, label: '프로' },
  { value: 'enterprise' as const, label: '엔터프라이즈' },
  { value: 'teacher' as const, label: '티처' },
  { value: 'class' as const, label: '클래스' },
  { value: 'realworld' as const, label: '리얼월드' },
] as const;

// 요금제 배지 메타데이터 (배경색, 텍스트색)
export const PLAN_META: Record<PlanType, { label: string; bg: string; fg: string }> = {
  free: { label: '무료', bg: '#F5F5F5', fg: '#8C8C8C' },
  pro: { label: '프로', bg: '#E3FEF2', fg: '#4E9E6F' },
  enterprise: { label: '엔터프라이즈', bg: '#E3FEF2', fg: '#4E9E6F' },
  teacher: { label: '티처', bg: '#E3FEF2', fg: '#4E9E6F' },
  class: { label: '클래스', bg: '#E3FEF2', fg: '#4E9E6F' },
  realworld: { label: '리얼월드', bg: '#FFFFFF', fg: '#000000' },
};

// 요금제 타입 레이블 가져오기 헬퍼 함수
export function getPlanLabel(planType?: string): string {
  if (!planType) return '무료';
  return PLAN_TYPE_LABELS[planType] || planType;
}

